import firebase from 'firebase'
const firebaseConfig = {
  apiKey: "AIzaSyAakYThkKJHA7oMMA6e6F0bAGthavX-WBk",
  authDomain: "memoireweb-fd1ca.firebaseapp.com",
  projectId: "memoireweb-fd1ca",
  storageBucket: "memoireweb-fd1ca.appspot.com",
  messagingSenderId: "841172362749",
  appId: "1:841172362749:web:81664822192da47165e594"
};
  const firebaseApp =firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  db.settings({ timestampsInSnapshots: true }); 

  const auth = firebase.auth();

  export {auth}
  export default db;
  